import { Box, Grid, Table } from "@mui/material";
import { useState } from "react";
import { connect } from "react-redux";
import { setSnack } from "../../models/application/applicationActions";
import { Product } from "../../models/Product/Product";
import { productService } from "../../models/Product/service";
import { ProductFormDialog } from "../Dialogs/ProductFormDialog";
import MainTableHeaderBodyContainer from "../MainTableHeaderBodyContainer";

const ProductsTable = (props: any) => {
  const { setSnack, app, tableName, handleSubmit, tableList, handleOrder, handleOnToggle, handleOnChange, selectedFilters, tableStructureList } = props;

  const localList = JSON.parse(localStorage.getItem(tableName) || "{}");
  const [cachedList, setCachedList] = useState<{ key: string; list: any[] }>({ key: "", list: [] });
  const [filteredList, setFilteredList] = useState<any[]>(Object.keys(localList).length ? localList : tableStructureList);
  const [product, setProduct] = useState<Product | null>(null);
  const [open, setOpen] = useState(false);

  const handleDialog = (state: boolean) => setOpen(state);

  const onAlert = (text: string) => setSnack({ ...app.snack, open: true, text: text });

  const getOverallTrueFalseFromFilteredList = () => {
    return filteredList.filter((e) => e.enabled === true).length ? true : false;
  };

  const handleCachedList = (item: { key: string; list: any[] }) => {
    setCachedList(item);
  };

  const handleFilteredList = (state: any[]) => {
    setFilteredList(state);
  };

  const handleEdit = (state: boolean, item: any) => {
    setOpen(state);
    setProduct(item);
  };

  return (
    <Box>
      <Grid item overflow={"overlay"}>
        <Table sx={{ width: getOverallTrueFalseFromFilteredList() ? "100%" : "fit-content" }} stickyHeader>
          <MainTableHeaderBodyContainer
            padding="checkbox"
            size="small"
            align="center"
            handleEdit={handleEdit}
            headerList={filteredList}
            handleOrder={handleOrder}
            handleOnToggle={handleOnToggle}
            handleCachedList={handleCachedList}
            handleOnChange={handleOnChange}
            selectedFilters={selectedFilters}
            cachedList={cachedList}
            handleFilteredList={handleFilteredList}
            handleSubmit={handleSubmit}
            updater={new Product()}
            service={productService}
            copySuccessMessage={"Id copied successfully"}
            tableList={tableList}
            tableName={tableName}
            detailsLinkToolVisible={false}
            copyToolVisible={false}
          />
        </Table>
      </Grid>
      <ProductFormDialog product={product} open={open} handleDialog={handleDialog} onAlert={onAlert} setSubmitted={handleSubmit} />
    </Box>
  );
};

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    app: state.app,
    palette: state.theme.palette,
    muiTheme: state.theme.muiTheme,
  };
};

export default connect(mapStateToProps, { setSnack })(ProductsTable);
